/*
 *
 * OrdersInProduction constants
 *
 */

export const DEFAULT_ACTION = 'app/OrdersInProduction/DEFAULT_ACTION';
export const SET_COMPARTMENT_VALUES = 'app/containers/EditControlModal/SET_COMPARTMENT_VALUES';
